import { queryKeys } from '../../shared';
import { useDelete, useSave } from '../../shared/hooks/new-base.hook';
import { useItem, UseItemParams, useList, UseListParams } from '../../shared/hooks/new-read-only.hook';
import { foodRestrictionClient } from '../clients/food-restriction.client';
import { IFoodRestriction } from '../models';

const client = foodRestrictionClient;
const listKey = queryKeys.FOOD_RESTRICTIONS;
const itemKey = queryKeys.FOOD_RESTRICTION;

export function useFoodRestrictionsList(...args: UseListParams<IFoodRestriction>) {
    return useList(client, listKey, args);
}

export function useFoodRestriction(...args: UseItemParams<IFoodRestriction>) {
    return useItem(client, itemKey, args);
}

export function useSaveFoodRestriction() {
    return useSave(client, listKey, itemKey);
}

export function useDeleteFoodRestriction() {
    return useDelete(client, listKey);
}
